import './assets/curbed.png';
import './assets/eater.jpg';
import './index.scss';

